// @ts-check
import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';
import { TemplateParties } from '@/store/modules/bulkSend/models/TemplateParties';

export const TemplateSummary = z.object({
  id: z.number(),
  fingerprint: z.string(),
  title: z.string(),
  filename: z.string(),
  total_pages: z.number(),
  created_at: Timestamp,
  updated_at: Timestamp,
  processed_at: Timestamp,
  images: z.array(z.string()),
});

export const TemplateSummaries = TemplateSummary.array();

export const ListTemplate = TemplateSummary.pick({
  id: true,
  fingerprint: true,
  title: true,
  created_at: true,
  images: true,
});

export const Template = TemplateSummary.extend({
  parties: TemplateParties,
});

export const Templates = Template.array();

/** @typedef {z.infer<typeof Template>} TTemplate */
/** @typedef {z.infer<typeof Templates>} TTemplates */
/** @typedef {z.infer<typeof ListTemplate>} TListTemplate */
